export default {
  "www-tran-ls-tab.comfortweather.com": {
    ad1: [
      {
        type: "adx",
        id: "div-gpt-ad-1780325847271-0",
        slot: "/23161678951/tran_ls_tab_comfortweather_20260531_320x100_top",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-08",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1780326003956-0",
        slot: "/23161678951/tran_ls_tab_comfortweather_20260531_320x100_under",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-01",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1780325934405-0",
        slot: "/23161678951/tran_ls_tab_comfortweather_20260531_320x100_center",
        rect: [320, 100],
        style: {
          minWidth: "320px",
          minHeight: "100px",
        },
        position: "position-36",
      },
    ],
    ad2: [
      {
        type: "adx",
        id: "div-gpt-ad-1780326088627-0",
        slot: "/23161678951/tran_ls_tab_comfortweather_20260531_320x250_1",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-09",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1780326160968-0",
        slot: "/23161678951/tran_ls_tab_comfortweather_20260531_320x250_2",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-13",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1780326649588-0",
        slot: "/23161678951/tran_ls_tab_comfortweather_20260531_320x250_3",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-14",
      },
      {
        type: "adx",
        id: "div-gpt-ad-1780326721621-0",
        slot: "/23161678951/tran_ls_tab_comfortweather_20260531_320x250_4",
        rect: [320, 250],
        style: {
          minWidth: "320px",
          minHeight: "250px",
        },
        position: "position-15",
      },
    ],
  },
};
